export enum InternalConsultantCaptureCursorType {
  mostRecentlyCreated = 'most_recently_created',
  highestEstimatedValue = 'highest_estimated_value',
  highestWipEstimatedValue = 'highest_wip_estimated_value',
  highestPatientEstimatedValue = 'highest_patient_estimated_value',
}
